import { useQuery } from '@tanstack/react-query';
import { apiClient } from 'api';

type ActivityFilter = 'cv_analysis' | 'generate_questions' | 'refine_question' | 'assessment_scoring' | 'cv_relevance' | 'strengths_gaps' | 'comparison' | 'share_report' | 'analytics' | 'collaborative_session' | 'jd_upload' | 'jd_generate';

export interface ExportUsageBreakdownParams {
  activity?: ActivityFilter;
  search?: string;
}

/**
 * Hook to export usage breakdown as CSV
 * Returns CSV data as a string
 */
export const useExportUsageBreakdown = (enabled: boolean = false, params?: ExportUsageBreakdownParams, ids?: string[]) => {
  return useQuery({
    queryKey: ['exportUsageBreakdown', params, ids],
    queryFn: async () => {
      const searchParams = new URLSearchParams();
      if (params?.activity) searchParams.append('activity', params.activity);
      if (params?.search) searchParams.append('search', params.search);
      if (ids?.length) searchParams.append('ids', ids.join(','));

      const queryString = searchParams.toString();
      const url = `/billing/dashboard/usage-breakdown/export/${queryString ? `?${queryString}` : ''}`;

      const response = await apiClient.get<string>(url);
      return response.data;
    },
    enabled,
    staleTime: 0, // Always fetch fresh data when enabled
  });
};
